import React, { useEffect, useState } from 'react';
import CircleLlama from '~/ui/llama-modal/llama-circle.svg';
import { Flex } from '../flex/Flex';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  from,
  to {
    transform: translateY(0) scale(1, 1);
    animation-timing-function: ease-in;
  }
  45% {
    transform: translateY(30px) scale(1, 1);
    animation-timing-function: linear;
  }
  50% {
    transform: translateY(30px) scale(1.5, 0.5);
    animation-timing-function: linear;
  }
  100% {
    transform: translateY(30px) scale(1, 1);
    animation-timing-function: ease-out;
  }
`;

const bounceShadow = keyframes`
  from,
  to {
    transform: translateY(5em) scale(0.5);
    filter: blur(5px);
  }
  45% {
    transform: translateY(5em) scale(0.5);
  }
  50% {
    box-shadow: 20px 0 5px rgba(0, 0, 0, 0.1), -20px 0 5px rgba(0, 0, 0, 0.1);
  }
  100% {
    transform: translateY(5em) scale(0.5);
    box-shadow: unset;
  }
`;

const PreLoaderWrapper = styled.div`
  width: 100px;
  position: relative;
  margin-right: 20px;
  margin-bottom: -80px;
  margin-top: 80px;
`;

const ShapeWrapper = styled.div`
  display: flex;
  align-items: center;
  transform: translateY(-5em);
`;

const Circle = styled.div`
  width: 25px;
  height: 25px;
  background-color: var(--color-accent-dk);
  border-radius: 50%;
  margin: 0 10px;
  animation: ${bounce} 0.8s linear infinite;

  &:nth-child(2) {
    background-color: var(--color-accent-dk);
    animation-delay: 0.1s;
  }

  &:nth-child(3) {
    animation-delay: 0.2s;
  }
`;

const ShadowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-5em);
`;

const ShapeShadow = styled.div`
  width: 50px;
  height: 18px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  margin: 0 1rem;
  animation: ${bounceShadow} 0.6s linear infinite;
  transform: translateY(5em) scale(0.5);

  &:nth-child(2) {
    animation-delay: 0.1s;
  }

  &:nth-child(3) {
    animation-delay: 0.2s;
  }
`;

const PreLoader = () => {
  return (
    <PreLoaderWrapper>
      <ShapeWrapper>
        <Circle />
        <Circle />
        <Circle />
      </ShapeWrapper>
      <ShadowWrapper>
        <ShapeShadow />
        <ShapeShadow />
        <ShapeShadow />
      </ShadowWrapper>
    </PreLoaderWrapper>
  );
};

const WrapperForLoaderAndText = styled.div`
  display: flex;
`;

export const Spinner = ({ backgroundColor = 'pinkLight2' }) => {
  const [text, setText] = useState('Loading...');

  const items = [
    'Swapping out our alpacas for llamas...',
    'Please wait while our llamas fetch your content...',
    'Loading...',
    'Llama loading...',
    'Please hold for the next available Llama...'
  ];

  useEffect(() => {
    setText(items[Math.floor(Math.random() * items.length)]);
  }, []);

  return (
    <Flex
      variant="center"
      backgroundColor={backgroundColor}
      flexDirection="column"
    >
      <CircleLlama />
      <WrapperForLoaderAndText>
        <PreLoader />
        <h3 style={{paddingTop: '20px'}}>{text}</h3>
      </WrapperForLoaderAndText>
    </Flex>
  );
};
